import { atom } from "jotai";
import HitRecord from "models/view-models/search/hit-record";

export const BookviewSearchResultsAtom = atom<HitRecord[]>([]);
